const SIDE_DICT = {
  buy: 'buy',
  sell: 'sell',
  up: 'buy',
  down: 'sell',
}
interface PnlPayload2 {
  asset: string
  entryPrice: number
  exitPrice: number
  fillQuantity: number
  side: keyof typeof SIDE_DICT
  leverage: number
  fundingFee: number
}

// const getFeeRate_OLD = (entryPr: number, exitPr: number): number => {
//   return 0.1
// }

const getFeeRate = (entryPr: number, exitPr: number, leverage: number, asset: string): number => {
  if (asset === 'PEPE/USD') return 0.4
  if (asset === 'WOJAK/USD') return 0.4

  const MIN_FEE_RATE = 0.05
  const MAX_FEE_RATE = 0.25
  let fee_rate
  try {
    let inverse_price
    if (Math.abs(entryPr - exitPr) > 0.0001) {
      const price_dff = (Math.abs(entryPr - exitPr) / entryPr) * 100
      inverse_price = 1 / price_dff
    } else inverse_price = 10000

    fee_rate =
      MIN_FEE_RATE +
      (MAX_FEE_RATE - MIN_FEE_RATE) *
        ((0.5 / (1 + Math.exp(50 - leverage)) + 0.5 / (1 + Math.exp(5 - inverse_price))) / 2 + 0.5)
  } catch {
    // In case if any indivisble or related error occurs
    fee_rate = 0.2
  }

  // logger.info('using fee rate =>', fee_rate)
  return fee_rate
}

export const getPnL = (
  entryPrice: number,
  exitPrice: number,
  side: keyof typeof SIDE_DICT,
  fillQuantity: number,
  leverage: number,
  asset: string,
): number => {
  let result

  if (SIDE_DICT[side] === 'buy') {
    //ACZ create a const for this
    if (exitPrice <= entryPrice) result = exitPrice - entryPrice
    else {
      const rate = getFeeRate(entryPrice, exitPrice, leverage, asset)
      result = (1 - rate) * (exitPrice - entryPrice)
    }
  } else if (SIDE_DICT[side] === 'sell') {
    //ACZ create a const for this
    if (exitPrice >= entryPrice) result = entryPrice - exitPrice
    else {
      const rate = getFeeRate(entryPrice, exitPrice, leverage, asset)
      result = (1 - rate) * (entryPrice - exitPrice)
    }
  } else throw new Error('pnl side is unspecified')

  return result * fillQuantity
}

export const getPnl2 = ({ asset, entryPrice, exitPrice, fillQuantity, side, leverage, fundingFee }: PnlPayload2) => {
  let pnl =
    side === 'buy'
      ? (exitPrice - entryPrice) * fillQuantity
      : (entryPrice - exitPrice) * fillQuantity

  const feeRate = getFeeRate(entryPrice, exitPrice, leverage, asset)
  pnl = (pnl * (1 - feeRate)) - fundingFee
  return Number(pnl.toFixed(3))
}